module.exports = __webpack_public_path__ + "img/canvas-night-warm.ae977e29.jpg";